import { createAction, props } from "@ngrx/store";
import { IOrganisation } from "../core/models/organisation.vm";

export const loadOrganisationList = createAction("[Organisation List] Load Organisation List");
export const loadOrganisationListSuccess = createAction("[Organisation List] Load Organisation List Success", props<{organisationlist: IOrganisation[]}>());
export const loadOrganisationListError = createAction("[Organisation List] Load Organisation List Error");